import { extractCss, setup } from 'goober';
import { h, render } from 'preact';
import AgentChatbotWidget from './AgentChatbotWidget';

// Step 1: Setup with Preact h()
setup(h, undefined);

class AgentChatbotWC extends HTMLElement {
    private styleTag: HTMLStyleElement;
    private mount: HTMLDivElement;
    private shadowRootRef: ShadowRoot;

    constructor() {
        super();

        this.shadowRootRef = this.attachShadow({ mode: 'open' });

        // Create mount point for Preact
        this.mount = document.createElement('div');
        this.shadowRootRef.appendChild(this.mount);

        // Create and append <style> tag for goober styles
        this.styleTag = document.createElement('style');
        this.shadowRootRef.appendChild(this.styleTag);
    }

    connectedCallback() {
        const apiKey = this.getAttribute('api-key') || '';

        // Render your app inside shadow root mount
        render(<AgentChatbotWidget apiKey={apiKey} />, this.mount);

        // Extract all goober CSS after render
        const css = extractCss();

        // Inject styles inside shadow root
        this.styleTag.textContent = css;

        // Global click listener
        document.addEventListener('click', this.handleDocumentClick, true);
    }

    disconnectedCallback() {
        render(null, this.mount);
        document.removeEventListener('click', this.handleDocumentClick, true);
    }

    handleDocumentClick = (event: MouseEvent) => {
        const el = (event.target as HTMLElement).closest(
            '.boostbuddy__action'
        ) as HTMLElement;
        if (el) {
            const message = el.dataset.message;
            if (message) {
                window.dispatchEvent(
                    new CustomEvent('boostbuddy-custom-event', {
                        detail: message
                    })
                );
            }
        }
    };
}

customElements.define('boostbuddy-ai-agent', AgentChatbotWC);
